import { MenuItem, Select } from "@mui/material";
import { QrDisplayConfig } from "../../types/qr-display-config";

interface QrDisplayConfigSelectProps {
  configs: QrDisplayConfig[];
  value: number | "";
  onChange: (qrDisplayConfigId: number | "") => void;
  disabled?: boolean;
  className?: string;
  minWidth?: string;
  placeholder?: string;
}

export function QrDisplayConfigSelect({
  configs,
  value,
  onChange,
  disabled,
  minWidth = "220px",
  placeholder,
}: QrDisplayConfigSelectProps) {
  return (
    <Select<number | "">
      size="small"
      disabled={disabled}
      value={value}
      displayEmpty
      onChange={(event) => {
        const nextValue = event.target.value;
        onChange(nextValue === "" ? "" : Number(nextValue));
      }}
      sx={{
        minWidth,
        fontFamily: "Montserrat",
        fontSize: "0.85rem",
        backgroundColor: "white",
        borderRadius: "9999px",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#838383",
        },
      }}
      renderValue={(selected) => {
        if (selected === "") {
          return (
            <span className="text-[#898989]">
              {placeholder ?? ""}
            </span>
          );
        }
        return (
          configs.find((config) => config.qrDisplayConfigId === selected)?.shortName ??
          String(selected)
        );
      }}
    >
      <MenuItem value="" sx={{ fontFamily: "Montserrat" }}>
        {placeholder ?? ""}
      </MenuItem>
      {configs.map((config) => (
        <MenuItem
          key={config.qrDisplayConfigId}
          value={config.qrDisplayConfigId}
          sx={{ fontFamily: "Montserrat" }}
          title={config.description}
        >
          {config.shortName}
        </MenuItem>
      ))}
    </Select>
  );
}
